import { useCallback, useState } from 'react';
import { AppButton, Flex } from '@/components';
import { PaymentHttp, UserHttp } from '@/services';
import { useTranslation } from 'react-i18next';

export interface GatewayInfoProps {
  gatewayInfo: GatewayInfoState;
}

const LegacyIncrementCredit = ({ gatewayInfo }: GatewayInfoProps) => {

  const [t] = useTranslation(['common', 'payment']);
  const [loading, setLoading] = useState(false);

  const amounts = [...(gatewayInfo?.amounts ?? [])] as any[];

  if (gatewayInfo.canCustomAmountPay) {
    amounts.push('custom');
  }

  const gotoPaymentPage = useCallback(() => {
    setLoading(true);
    UserHttp.loginToken().then(response => {
      PaymentHttp.openCreditIncreasePage(response.data?.payload?.loginAsToken);
    }).finally(() => setLoading(false));
  }, []);

  return (
    <Flex direction="column" className="mt-auto">
      <Flex direction="column" gap={10}>
        <AppButton
          size="middle"
          appVariant="submit"
          loading={loading}
          onClick={gotoPaymentPage}
        >
          {t('payment:labels.go-payment-page')}
        </AppButton>
      </Flex>
    </Flex>
  );
};

export default LegacyIncrementCredit;
